
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Loader} from "@/utils/Loader";
import {Contact, ContactType} from "@/shared/domain/General";

@Component({
  components: {}
})
export default class ContactSelector extends Vue {
  loader = Loader.create()

  @Prop() value!: Contact

  @Prop({required: true, type: Function}) resolver!: () => Promise<Array<Contact>>
  @Prop({
    required: false,
    type: Array,
    default: () => [ContactType.PERSON, ContactType.ORGANISATION]
  }) contactTypes!: ContactType[]


  allContacts: Array<Contact> = []
  contacts: Array<Contact> = []

  set contactType(type: ContactType | undefined) {
    this.updateContacts(type)
    if (this.value && this.value.type !== type) {
      if (this.contacts[0]) {
        this.contactRef = this.contacts[0].ref
      } else {
        this.contactRef = undefined
      }
    }
  }

  get contactType(): ContactType | undefined {
    return this.value ? this.value.type : undefined
  }

  set contactRef(contactRef: string | undefined) {
    const c = this.allContacts.find(it => it.ref == contactRef)
    if (c) {
      this.$set(this.value, "ref", c.ref)
      this.$set(this.value, "name", c.name)
      this.$set(this.value, "type", c.type)
    } else {
      this.$set(this.value, "ref", undefined)
      this.$set(this.value, "name", undefined)
      this.$set(this.value, "type", undefined)
    }
  }

  get contactRef(): string | undefined {
    return this.value ? this.value.ref : undefined
  }

  mounted() {
    this.allContacts = []
    this.loader.load(async () => {
      await this.resolver()
          .then((r) => {
            this.allContacts = r
            this.contactType = (this.value ? this.value.type : undefined) || ContactType.PERSON
          })
    })
  }

  updateContacts(type: ContactType | undefined) {
    this.contacts = this.allContacts.filter(it => it.type == type)
    if (this.contacts.length > 0 && !this.value.ref) {
      this.contactRef = this.contacts[0].ref
    }
  }

  get contactTypesThatHaveContacts() {
    return this.contactTypes.filter(ct => this.allContacts.filter(it => it.type == ct).length > 0).map(it => {
      return {
        value: it,
        text: this.$t(`members.profile.table.label.billto_${it}`)
      }
    })
  }
}
